// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4738) return "static/chunks/4738.140bd1126f90e2fa.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"886":"f6099d52fb88adc5","1664":"82be2fee8386b62b","9424":"d6d659572e351250"}[chunkId] + ".js";
};